import React from 'react';
import { Outlet } from 'react-router-dom';
import { ToastProvider } from './shared/ToastProvider';
import './shared/emailDesign.css';
import './EmailModule.css';

const EmailModule = () => {
  return (
    <ToastProvider>
      <div className="email-module">
        <div className="email-module-content">
          <Outlet />
        </div>
      </div>
    </ToastProvider>
  );
};

export default EmailModule;
